module.exports = __webpack_public_path__ + "static/roundhouse-4d3ce35c93d91af556a721e73afc54d0.png";